<template>
    <div class="post-breadcrumbs-section">
        <ul v-if="breadcrumbs && Object.keys(breadcrumbs).length" class="breadcrumbs-ul">
            <li v-if="breadcrumbs.parent_project_id && breadcrumbs.parent_project_title" class="goto-parent-link"
                @click="goToParentProject(breadcrumbs.parent_project_number)">
                {{ breadcrumbs.parent_project_title }}
                <span
                    v-if="breadcrumbs.parent_project_status.slug && breadcrumbs.parent_project_status.slug == 'on-hold'">
                    ({{ breadcrumbs.parent_project_status.name }})
                </span>
            </li>
            <li v-else-if="breadcrumbs.parent_project_id && !breadcrumbs.parent_project_title" class="goto-parent-link"
                @click="goToParentProject(breadcrumbs.parent_project_number)">
                UNTITLED PROJECT
            </li>
            <li v-else>
                NO PROJECT
            </li>
            <li class="breadcrumbs-icon"></li>
            <li v-if="breadcrumbs.parent_deliverable_id && breadcrumbs.parent_deliverable_title"
                class="goto-parent-link" @click="goToParentPlan(breadcrumbs.parent_deliverable_id)">
                {{ breadcrumbs.parent_deliverable_title }}
            </li>
            <li v-else-if="breadcrumbs.parent_deliverable_id && !breadcrumbs.parent_deliverable_title"
                class="goto-parent-link" @click="goToParentPlan(breadcrumbs.parent_deliverable_id)">
                UNTITLED PLAN
            </li>
            <li v-else>
                NO PLAN
            </li>
        </ul>
    </div>
</template>
<script>
import { mapMutations } from "vuex";

export default {
    props: [
        "breadcrumbs",
        "namespace",
    ],
    methods: {
        ...mapMutations({
            setDataLoading(commit, payload) {
                return commit(this.namespace + 'setDataLoading', payload)
            },
        }),


        goToParentProject(projectNumber) {
            this.setDataLoading(true);
            this.$bvModal.hide('editSocialModal');
            if (this.$router.currentRoute.path.indexOf('/project/') != -1) {
                // already in project detail page
                // close both modals and scroll to top
                this.$bvModal.hide('editOrganicSocialMediaPlanModal');
                this.$nextTick(() => {
                    const contentDivElement = document.getElementById('content');
                    if (contentDivElement) {
                        contentDivElement.scrollTo({
                            top: 0,
                            behavior: 'smooth'
                        });
                    }
                });
            } else {
                this.$router.push('/project/' + projectNumber);
            }
        },
        goToParentPlan(parentDeliverableId) {
            this.$root.$emit('showEditOSMPModal', parentDeliverableId);
        },
    },
}
</script>


<style scoped>
.breadcrumbs-ul {
    list-style: none;
    display: flex;
    padding: 0;
    margin: 0;
    background: var(--wf-secondary);
    border-radius: 5px;
    overflow: hidden;

    li {
        display: flex;
        align-items: center;
        padding: 0 0 10px 0;
        text-decoration: none;
        text-transform: uppercase;
        color: var(--wf-primary);
        font-size: 13px;

        &.breadcrumbs-icon {
            &::after {
                margin: 0 5px;
                font-family: "Font Awesome 6 Free";
                font-weight: 900;
                content: "\F054";
            }
        }

        &.goto-parent-link {
            &:hover {
                font-weight: 700;
                cursor: pointer;
                color: var(--db-sidebar-ul-li-a-active-bg);
            }
        }

    }
}
</style>